import { createReducer } from '../../helpers/reducers';

import { types } from '../../actions/events';
import { types as searchTypes } from '../../actions/search';

const initialState = {};

const handleEventsShowSuccess = (state, action) => {
  const { data } = action.payload;

  return {
    ...state,
    [data.id]: data,
  };
};

const handleEventsTicketsSuccess = (state, action) => {
  const { data, id } = action.payload;

  const { ticketList } = data;
  return {
    ...state,
    [id]: {
      ...state[id],
      ticketList,
    },
  };
};

const handleEventsTicketsCuratedSuccess = (state, action) => {
  const { data, id } = action.payload;

  const {
    recommendedList,
    ticketList,
    recommendationId,
  } = data;

  return {
    ...state,
    [id]: {
      ...state[id],
      ticketList,
      recommendedList,
      recommendationId,
    },
  };
}

const toObjectOfIds = (state, action) => {
  const { data } = action.payload;
  const nextState = { ...state };

  data.forEach((result) => {
    nextState[result.id] = result;
  });

  return nextState;
};

const handleEventsLatestSuccess = toObjectOfIds;
const handleSearchQuerySuccess = toObjectOfIds;


const handlers = {
  [types.EVENTS_SHOW.SUCCESS]: handleEventsShowSuccess,
  [types.EVENTS_LATEST.SUCCESS]: handleEventsLatestSuccess,
  [types.EVENTS_TICKETS.SUCCESS]: handleEventsTicketsSuccess,
  [types.EVENTS_TICKETS_CURATED.SUCCESS]: handleEventsTicketsCuratedSuccess,

  [searchTypes.SEARCH_QUERY.SUCCESS]: handleSearchQuerySuccess,
};

const byId = createReducer(initialState, handlers);

export default byId;

export const getEventsById = state => state.events.byId;
export const getEventsRecommendationId = id => state => getEventsById(state)[id].recommendationId;



// WEBPACK FOOTER //
// ./src/reducers/events/byId.js